import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import {
  VAULT_CONTENT_MAX_WIDTH,
  VAULT_PAGE_SIDE_PADDING,
} from "./VaultPage.constants";

export const useVaultPageStyles = makeStyles({
  root: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    padding: `${designTokens.spacing[8]} ${VAULT_PAGE_SIDE_PADDING}`,
  },
  contentInner: {
    maxWidth: VAULT_CONTENT_MAX_WIDTH,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
});
